import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';

import styles from './annual_kilometres.css';

class _AnnualKilometres extends Component {

    /**
     * Don't re-render unless annualKilometres has changed
     * @param {Object} nextProps - The incoming set of props
     * @returns {Boolean} - True if the component should re-render
     */
    shouldComponentUpdate = (nextProps) => {
        const { annualKilometres } = this.props;
        return nextProps.annualKilometres !== annualKilometres;
    };

    /**
     * Get the Weekly Kilometres rounded to the nearest ten
     * @returns {number} Weekly kilometres
     */
    getWeeklyKilometres = () => {
        const { annualKilometres } = this.props;
        const annual = parseInt(annualKilometres, 10);
        const weekly = annual / 52;
        return (Math.round(weekly / 10) * 10);
    };

    /**
     * Returns the Message Component
     * @returns {Node} Message Component
     */
    renderMessage = () => {
        const weeklyKilometres = this.getWeeklyKilometres();
        return weeklyKilometres !== 0 ? (
            <div className={styles.container}>
                <span className={styles.message}>
                    {`This works out to be around ${weeklyKilometres} KM's per week.`}
                </span>
            </div>
        ) : null;
    };

    /**
     * Returns the AnnualKilometres Component
     * @returns {Node} AnnualKilometres Component
     */
    render = () => {
        const { annualKilometres } = this.props;
        return annualKilometres !== '' ? this.renderMessage() : null;
    };

}

_AnnualKilometres.propTypes = {
    annualKilometres: PropTypes.string,
    annualKilometresStateKey: PropTypes.string // eslint-disable-line react/no-unused-prop-types
};

/**
 * Map annualKilometres to our local component props
 * @param {Object} state - the application state
 * @param {Object} props - the incoming set of props
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state, props) => {
    const form = quoteFormSelector(state);
    const annualKilometresStateKey = props.annualKilometresStateKey;
    return {
        annualKilometres: form.getIn([...annualKilometresStateKey.split('.')]) || ''
    };
};

const AnnualKilometres = connect(mapStateToProps)(_AnnualKilometres);
export { _AnnualKilometres, AnnualKilometres };
